import styled from '@emotion/styled';

export const ArrowStyle = styled.div`
  width: 36px;
  z-index: 100;
  &:before {
    display: none;
  }
`